import React, { useState, useEffect } from 'react';
import MarsNavbar from './components/MarsNavbar';
import SectionContainer from './components/SectionContainer';
import ProjectCard from './components/ProjectCard';
import SkillMeter from './components/SkillMeter';
import MissionSchedule from './components/MissionSchedule';
import StarField from './components/StarField';
import VisitorCounter from './components/VisitorCounter';
import LaunchingRocket from '../LaunchingRocket/LaunchingRocket';
import { usePortfolioData } from '../../hooks/usePortfolioData';
import './MarsTheme.css';

const Mars = () => {
  const { data: portfolioData, loading } = usePortfolioData();
  const [activeCategory, setActiveCategory] = useState("playstore");

  // Revised Scroll Logic: Highlight section closest to the center of the screen
  // IntersectionObserver for robust scroll detection
  useEffect(() => {
    const sections = document.querySelectorAll('.category-section');

    // Options: Trigger when 40% of the section is visible
    const observerOptions = {
      root: null, // viewport
      rootMargin: '-15% 0px -50% 0px', // Active when section is in upper-middle
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveCategory(entry.target.getAttribute('id'));
        }
      });
    }, observerOptions);

    sections.forEach(section => observer.observe(section));

    return () => {
      if (observer) observer.disconnect();
    };
  }, [loading]);

  const handleResumeClick = () => {
    window.open(portfolioData?.about?.resumeUrl, '_blank');
  };

  if (loading || !portfolioData) {
    return <LaunchingRocket isLoader={true} />;
  }

  return (
    <div className="mars-container">
      <StarField speedFactor={0.5} />
      <div className="content-layer">
        <header className="hero-section fade-in">
          <h1>{portfolioData.about.title}</h1>
          <p className="mission-brief">{portfolioData.about.description}</p>

          <button
            className="btn-primary hero-btn"
            onClick={handleResumeClick}
          >
            Access Mission Logs (Resume)
          </button>

          <SkillMeter skills={portfolioData.about.skills} />
        </header>

        <MarsNavbar
          categories={portfolioData.categories}
          activeCategory={activeCategory}
          onSelectCategory={(id) => {
            setActiveCategory(id);
            const element = document.getElementById(id);
            if (element) {
              // Offset for sticky navbar (approx 80px)
              const offset = 100;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;
              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
              });
            }
          }}
        />

        <div className="portfolio-grid">
          {portfolioData.categories.map(category => (
            <SectionContainer
              key={category.id}
              id={category.id}
              title={category.title}
              className="category-section"
              layout={category.layout}
            >
              {category.items.map((item, idx) => (
                <ProjectCard key={item.id} item={item} index={idx} />
              ))}
            </SectionContainer>
          ))}
        </div>

        <MissionSchedule availability={portfolioData.availability} />

        <footer className="mars-footer">
          <p>© 2154 Marsman | Status: Online</p>
          <VisitorCounter />
          <button className="return-btn" onClick={() => window.location.href = '/'}>
            <span className="arrow">➜</span> Return to Earth
          </button>
        </footer>
      </div>
    </div>
  );
};

export default Mars;
